import React from 'react';
import { withRouter } from "react-router-dom";
import qs from 'query-string';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { loadAgencyPaymentDetails } from "../../api/applications";
import {PaymentPlanForm} from "../PaymentPlanForm/PaymentPlanForm";
import cn from './AgencyProfileForm.module.scss';

class AgencyProfileFormContent extends React.PureComponent {
  state = {
    minPrice: '',
    maxPrice: '',
    paymentPlans: [],
    isAgencySpecific: false,
  }

  componentDidMount() {
    const queryParams = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    loadAgencyPaymentDetails({ agencyNonce: queryParams.agency_nonce }).then(({ minPrice, maxPrice, paymentPlans, isAgencySpecific })=>{
      this.setState({ minPrice, maxPrice, paymentPlans, isAgencySpecific });
    });
  }

  handleChange = (event, checked) => {
    this.setState({isAgencySpecific: checked});
  }

  render() {
    const { minPrice, maxPrice, paymentPlans, isAgencySpecific } = this.state;
    return (
      <div>
        <div className={cn.row}>
          Payment plans (based on agency hierarchy): { paymentPlans.map(plan => {
            return (
              <div>
                Price: ${plan.price} {plan.default ? '(Default)' : ''} - {plan.options.map(option => {
                  return option.months === 1 ? 'One time(no fee)' : `${option.months}-months($${option.fee} fee)`;
                }).join(', ')}
              </div>
            );

          }) }
        </div>
        <div className={cn.row}>
          Override defaults:
          <FormControlLabel
            control={
              <Switch
                name="isAgencySpecific"
                value="1"
                checked={isAgencySpecific}
                onChange={this.handleChange}
                color="primary"
              />
            }
          />
        </div>
        {isAgencySpecific && <PaymentPlanForm minPrice={minPrice} maxPrice={maxPrice} initialPlans={paymentPlans} />}
      </div>
    )
  }
}

export const AgencyProfileForm = withRouter(AgencyProfileFormContent);
